module.exports = __webpack_public_path__ + "img/hero-still_cn.9bc10bb.jpg";